import { useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as actions from '@actions'
import qs from 'qs'

import { Message } from '@components/shared/Message'

const ForgotPassword = () => {
    
    const navigate = useNavigate()
    const location = useLocation()
    
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState()
    
    const setNoEmailMessage = () => setMessage({
        text: 'Please enter an email address',
        level: 'danger',
    })
    
    const setNoExistsMessage = () => setMessage({
        text: 'The email provided is not associated with any account',
        level: 'danger',
    })
    
    const onSubmit = useCallback(async e => {
        
        e.preventDefault()
        setMessage()
        
        if (!email?.length)
            return setNoEmailMessage()
        
        try {
            
            const exists = await actions.checkUserExists(email.trim())
            
            if (!exists)
                return setNoExistsMessage()
            
            await actions.sendResetPasswordEmail(email.trim())
            
            navigate(`/resetpasswordemailsent?email=${email.trim()}`)
            
        } catch (e) {
            
            console.error('ForgotPassword#onSubmit', e)
            setMessage({
                text: 'Reset password failed, please try again.',
                level: 'danger',
            })
            
        }
        
    }, [email])
    
    useEffect(() => {
        
        let email = qs.parse(location.search, { ignoreQueryPrefix: true }).email
        
        if (typeof email === 'string')
            setEmail(email)
        
    }, [location])
    
    return (
        
        <div
            className="flex justify-center items-center max-w-screen-lg mx-auto w-6/12 py-20 px-20"
            style={{ height: '99vh' }}>
            
            <div className="w-96 mx-auto">
                
                <div
                    style={{
                        marginBottom: '25px',
                        width: '80%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '0 auto 20px',
                    }}>
                    <img src="img/logo.png" width="100%" height="100%" alt="" />
                </div>
                
                {message && <Message message={message} onDismiss={() => setMessage()} />}
                
                <div className="text-center">
                    
                    <h2>Forgot your password?</h2>
                    <p>Provide an email and we will send you a password change request via email.</p>
                    
                    <form onSubmit={onSubmit} className="mt-5">
                        <div className="form-group">
                            <p className="mb-2 text-muted">Confirm email address (Required)</p>
                            <input
                                className="input input-bordered w-full"
                                type="email"
                                value={email}
                                placeholder="example@email.com"
                                onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className="mb-2 form-group mt-2">
                            <div className="input-group input-group-merge ">
                                <input
                                    type="submit"
                                    value="Send Email"
                                    className="mb-3 btn btn-lg btn-block btn-primary btn-outline"/>
                            </div>
                        </div>
                    </form>
                    
                    <span
                        className="text-muted"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/signin')}>
                        Back to sign in
                    </span>
                
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default ForgotPassword
